module.exports = __webpack_public_path__ + "static/media/e15.5a94a2db.jpg";